// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"354cdb4b","294":"a6525967"}[chunkId] + ".chunk.css";
};